import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, FileText, Calendar, Target, Users, ClipboardCheck } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: Calendar,
    text: '24 sesiones profesionales estructuradas'
  }, {
    icon: Target,
    text: 'Objetivos claros por sesión'
  }, {
    icon: FileText,
    text: 'Actividades específicas para dislexia'
  }, {
    icon: ClipboardCheck,
    text: 'Fichas imprimibles listas para usar'
  }, {
    icon: FileText,
    text: 'Registro clínico por sesión'
  }, {
    icon: Target,
    text: 'Seguimiento del progreso del niño'
  }, {
    icon: Users,
    text: 'Comunicación clara con las familias'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-131">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="max-w-4xl mx-auto" data-id="element-133">
          <div className="text-center mb-16" data-id="element-134">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-135">
              La solución no es más teoría
            </h2>
            <p className="text-2xl text-teal-600 font-bold mb-6" data-id="element-136">
              Es un sistema profesional listo para usar
            </p>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-137">
              Un recorrido claro, organizado y progresivo para intervenir en
              dislexia, con sesiones armadas, actividades específicas y
              registros clínicos incluidos.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-16" data-id="element-138">
            <div className="bg-teal-600 p-6 text-center" data-id="element-139">
              <h3 className="text-xl font-bold text-white" data-id="element-140">
                MEGA PACK DE INTERVENCIÓN EN DISLEXIA
              </h3>
              <p className="text-teal-100 mt-2" data-id="element-141">
                Un sistema completo en PDF, diseñado para psicopedagogas que
                trabajan en consultorio
              </p>
            </div>

            <div className="p-8 md:p-10" data-id="element-142">
              <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-143">
                {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-144">
                    <div className="bg-teal-50 p-2 rounded-full flex-shrink-0" data-id="element-145">
                      <CheckCircle2 className="w-5 h-5 text-teal-600" data-id="element-146" />
                    </div>
                    <span className="text-slate-700 font-medium" data-id="element-147">
                      {feature.text}
                    </span>
                  </div>)}
              </div>

              <div className="text-center bg-slate-50 rounded-xl p-6 border border-slate-100" data-id="element-148">
                <p className="text-lg font-medium text-slate-800 mb-4" data-id="element-149">
                  👉 Descargás. Imprimís. Aplicás.
                </p>
                <p className="text-slate-600 mb-6" data-id="element-150">
                  Sin inventar. Sin perder tiempo. Sin dudar frente al niño.
                </p>
                <Button href="https://checkout.ebookditales.com/cart/42846653874239:1" fullWidth className="md:w-auto" data-id="element-151">
                  Quiero el sistema completo ahora
                </Button>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-152">
            <div data-id="element-153">
              <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-154">
                Imaginá esto por un momento...
              </h3>
              <div className="space-y-4 text-slate-600" data-id="element-155">
                <p data-id="element-156">
                  Abrís el PDF. Sabés exactamente qué sesión toca. Tenés las
                  actividades listas. Entrás al consultorio con seguridad.
                </p>
                <p data-id="element-157">No improvisás. No dudás. No cargás con culpa profesional.</p>
                <p className="font-medium text-slate-800" data-id="element-158">
                  Terminás la jornada y no te llevás trabajo a casa.
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border border-slate-100" data-id="element-159">
              <h4 className="font-bold text-slate-900 mb-4 border-b border-slate-100 pb-2" data-id="element-160">
                Lo que este sistema te devuelve
              </h4>
              <ul className="space-y-3" data-id="element-161">
                <li className="flex items-center gap-3" data-id="element-162">
                  <span className="text-xl" data-id="element-163">🕒</span>
                  <span className="text-slate-700" data-id="element-164">
                    Horas reales de tu semana
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-165">
                  <span className="text-xl" data-id="element-166">🧠</span>
                  <span className="text-slate-700" data-id="element-167">
                    Orden mental y claridad clínica
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-168">
                  <span className="text-xl" data-id="element-169">📁</span>
                  <span className="text-slate-700" data-id="element-170">
                    Material profesional coherente
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-171">
                  <span className="text-xl" data-id="element-172">😌</span>
                  <span className="text-slate-700" data-id="element-173">Tranquilidad en sesión</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-174">
                  <span className="text-xl" data-id="element-175">👩‍⚕️</span>
                  <span className="text-slate-700" data-id="element-176">
                    Autoridad frente a familias y escuelas
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}